import './src/js/image_gallery.js';
import './src/js/milodrama.js';
import './src/js/yandex_commerce.js';
import './src/js/scripts.js';
import './src/js/product_popup.js';
import './src/js/bonuses.js';
import 'slick-carousel';

require("jquery");
require("godlike.css");
require("lightbox2");

// noinspection JSUnusedAssignment
var __svg__ = { path: './src/img/*.svg', name: './sprite.svg' };
__svg__ = {filename: './local/templates/friday/media/assets/sprite.svg'};
require('webpack-svgstore-plugin/src/helpers/svgxhr')(__svg__);



//////////////////
// WEBPACK FOOTER
// ./build.js
// module id = 1
// module chunks = 0 1 2